import Layout from '@/layout/layout'

const classificationRouter = {
    path: '/lowPhonemanagement',
    component: Layout,
    redirect: 'noRedirect',
    name: '低端机管理',
    children: [
        {
            path: "lowMachine",
            component: () => import("@/views/lowPhonemanagement/lowMachine/index"),
            name: "低端机报价管理",
            meta: { title: "低端机报价管理", noCache: true },
        },
        {
            path: "functionQuotation",
            component: () => import("@/views/lowPhonemanagement/functionQuotation/index"),
            name: "功能机报价管理",
            meta: { title: "功能机报价管理", noCache: true },
        },
    ]
}

export default classificationRouter